export default { 
  name : 'product.event.expectedProductId',
  objectType : 'product.event',
  valueType : 'string',
  displayName : 'Expected Product ID',
  get : ( obj, cxt ) => {
    return obj?.data?.data?.expectedProductId
  }
}
